import { render, staticRenderFns } from "./ListSmsComponent.vue?vue&type=template&id=2df16bdd&scoped=true&"
import script from "./ListSmsComponent.vue?vue&type=script&lang=js&"
export * from "./ListSmsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df16bdd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/jktan/Documents/workplaces/Work/Han_Productions/FRS_System/Web/frontend/jk-work-frs-frontend-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VExpansionPanel } from 'vuetify/lib'
import { VExpansionPanelContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VContainer,VDataTable,VDialog,VDivider,VExpansionPanel,VExpansionPanelContent,VFlex,VIcon,VLayout,VSpacer})
